module.exports = __webpack_public_path__ + "static/media/5-noactive.d14ccc8a.svg";